export const actions = {
  async 'aiAssistant.sendMessage'({}, { conversationId, content }) {
    return await this.$axios.$post(`AiAssistant/ProcessContent`, { conversationId, content });
  },
};
